module.exports = __webpack_public_path__ + "static/media/xslego-3-define.93e706b6.png";